module.exports = __webpack_public_path__ + "img/game--madden-22.ad7407ce.png";